import { apiClient } from './apiClient';
import type { Segment } from '../types/segments';

/**
 * Segment Service
 * Handles API calls for segment data
 */
export const segmentService = {
    /**
     * Get all segments for an episode
     */
    async getSegmentsByEpisode(episodeId: string): Promise<Segment[]> {
        const response = await apiClient.get(`/episodes/${episodeId}/segments`);
        return response.data.data; // API returns { success: true, data: [...] }
    },
};
